import { render } from "./AmlSurveyView.vue.ts?vue&type=template&id=32fc8d3f&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AmlSurveyView.vue?vue&type=template&id=32fc8d3f&ts=true"
import script from "./AmlSurveyView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AmlSurveyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AmlSurveyView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AmlSurveyView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/credit-line/views/Withdraw/AmlSurveyView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32fc8d3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32fc8d3f', __exports__)) {
    api.reload('32fc8d3f', __exports__)
  }
  
  module.hot.accept("./AmlSurveyView.vue.ts?vue&type=template&id=32fc8d3f&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./AmlSurveyView.vue?vue&type=template&id=32fc8d3f&ts=true", () => {
    api.rerender('32fc8d3f', render)
  })

}


export default __exports__